module.exports = __webpack_public_path__ + "static/img/topright+++.0fc5791.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topright+++.png
// module id = HVLM
// module chunks = 1